import {Box, BoxProps, Typography} from '@logistics-frontend/blocks'
import clsx from 'clsx'
import React from 'react'

import {useAction} from '../../../../actions'
import type {ActionConfig} from '../../../../actions/types'
import * as classes from './Tag.classes'

type TagProps = Pick<BoxProps<'div'>, 'm' | 'mt' | 'mb' | 'ml' | 'mr' | 'mx' | 'my'> & {
  action: ActionConfig
  children: React.ReactNode
}

export const Tag = ({action, children}: TagProps): React.ReactElement => {
  const {ActionComponent, triggerAction} = useAction(action)

  return (
    <>
      <Box
        className={clsx(classes.tag, triggerAction && classes.clickable)}
        flexDirection="row"
        onClick={triggerAction}
        px="m"
        py="s"
      >
        <Typography variant="caption1">{children}</Typography>
      </Box>
      {ActionComponent}
    </>
  )
}
